module.exports = __webpack_public_path__ + "static/media/logotyp.07f0a55e.png";